import { Type } from "@scalar/typebox";
const MetaSchema = Type.Partial(
  Type.Object({
    title: Type.String(),
    description: Type.String(),
    ogTitle: Type.String(),
    ogDescription: Type.String(),
    ogImage: Type.String(),
    twitterCard: Type.String()
  })
);
const defaultMeta = {
  title: "Scalar API Reference",
  description: "Scalar API Reference",
  ogTitle: "Scalar API Reference",
  ogDescription: "Scalar API Reference",
  ogImage: "https://scalar.com/images/scalar-logo.png",
  twitterCard: "summary_large_image"
};
export {
  MetaSchema,
  defaultMeta
};
//# sourceMappingURL=meta.js.map
